module.exports = __webpack_public_path__ + "img/baremetal.dbee5d15.svg";